<template>
  <div class='consignor-daily'>
    <div class='nav'>
      <el-form :model='form' label-width='80px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='供应商:'>
          <el-input v-model='form.supplierName' size='mini' placeholder='请输入托运商名称'></el-input>
        </el-form-item>
        <el-form-item label='扣款原由:'>
          <el-input v-model='form.deductionReasonDesc' size='mini' placeholder='请输入扣款原由'></el-input>
        </el-form-item>
        <el-form-item label='违反时间:'>
          <el-date-picker v-model='form.startDate' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='开始日期' />
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='form.endDate' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='结束日期' />
        </el-form-item>
        <el-form-item label='是否生成对账单:' label-width='130px'>
          <el-select v-model='form.isStatement' filterable size='mini' placeholder='请选择状态'>
            <el-option label='全部' value=''></el-option>
            <el-option label='否' value='0'></el-option>
            <el-option label='是' value='1'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>新增</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='tableData'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' type='index' align='center' width='50px' />
          <el-table-column prop='supplierName' label='供应商' align='center' />
          <el-table-column prop='deductionReasonDesc' label='扣款原由' align='center' />
          <el-table-column prop='deduction' label='扣款金额(元)' align='center' />
          <el-table-column prop='deductionTime' label='违反时间' align='center'>
            <template slot-scope='scope'>
              {{ scope.row.deductionTime |formatTime }}
            </template>
          </el-table-column>
          <el-table-column prop='isStatement' label='是否生成对账单' align='center'
                           :formatter='isStatementFormat' />
          <el-table-column label='操作' width='250' align='center'>
            <template slot-scope='scope'>
              <el-button size='mini' class='searchBtn' type='primary'
                         @click='detailClick(scope.row)'>详情
              </el-button>
              <el-button size='mini' class='yellow-bg' @click='modifyClick(scope.row)'
                         v-if='scope.row.isStatement === 0'>修改
              </el-button>
              <el-button size='mini' type='danger' @click='rejectClick(scope.row)'
                         v-if='scope.row.isStatement === 0'>
                取消申请
              </el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <el-dialog :title='dialogTitle' :visible.sync='addFlag' width='700px' center
               @close='dialogClose'>
      <div class='add'>
        <div class='baseInfo'>

          <div class='baseInfoContent'>

            <el-form :model='modifyData' label-width='110px' label-position='right' :rules='rules'
                     ref='ruleForm' class='demo-ruleForm'>
              <div-border label='基础信息' prop='plan'>
                <div class='yang'>
                  <el-form-item label='供应商类型:' prop='supplierType' style='margin-top: 15px'>
                    <el-radio-group v-model='modifyData.supplierType'
                                    @change='radioChange(modifyData.supplierType,1)'>
                      <el-radio :label='1'>公路供应商</el-radio>
                      <el-radio :label='2'>水路供应商</el-radio>
                      <el-radio :label='3'>港口及其他</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label='选择供应商:' prop='supplierName'>
                    <el-select v-model='modifyData.supplierName' filterable size='mini'
                               placeholder='请选择供应商'>
                      <el-option v-for='(item,index) in selectData'
                                 :key='`${index}a`' :label='item.name' :value='item.name' />
                    </el-select>
                  </el-form-item>
                  <el-form-item label='扣款金额:' prop='deduction'>
                    <el-input v-model='modifyData.deduction' size='mini' placeholder='请输入扣款金额' />
                  </el-form-item>
                  <el-form-item label='扣款时间:' prop='deductionTime'>
                    <el-date-picker v-model='modifyData.deductionTime' size='mini'
                                    style='width:430px'
                                    value-format='yyyy-MM-dd' type='date' placeholder='请选择扣款时间' />
                  </el-form-item>
                  <el-form-item label='税率:' prop='taxRate'>
                    <el-input v-model='modifyData.taxRate' size='mini' placeholder='请输入税率' />
                  </el-form-item>
                  <el-form-item label='扣款原由:' prop='deductionReasonDesc'>
                    <el-input v-model='modifyData.deductionReasonDesc' size='mini'
                              placeholder='请简单描述扣款原由' />
                  </el-form-item>

                  <el-form-item label='详情原由:' prop='deductionReasonDetail'>
                    <el-input style='width: 430px;'
                              type='textarea'
                              :autosize='{ minRows: 2, maxRows: 6}'
                              placeholder='请详细描述扣款原由'
                              v-model='modifyData.deductionReasonDetail' size='mini' />
                  </el-form-item>
                </div>


              </div-border>
              <div-border label='上传附件' :is-need='true'>
                <el-form-item style='margin-top:15px; '>
                  <div class='imgUp'>
                    <el-upload
                      ref='upload'
                      class='upload-demo'
                      :action='uploadUrl'
                      :auto-upload='true'
                      :before-upload='beforeAvatarUpload'
                      :show-file-list='false'
                      :data='uploadData'
                      :on-change='uploadChange'
                      :on-success='(res) => uploadImgFun(res, 2)'
                      :file-list='modifyData.img'
                      :limit='5'
                    >
                      <!--                    <i class="el-icon-plus"/>-->
                      <el-button size='small' type='primary'>点击上传</el-button>
                      <div slot='tip' style='margin-top: 6px;margin-left: 10px'>支持扩展名：.rar .zip .doc
                        .docx .pdf .jpg...
                      </div>
                    </el-upload>
                    <div v-for='(item,index) in modifyData.img'>
                      <div class='upload'>{{ item.name }}
                        <div>
                          <i class='el-icon-loading' v-if="item.status !=='success'"></i>
                          <i class='el-icon-zoom-in' @click='handlePictureCardPreview(item,index)'
                             v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                             ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                          <i class='el-icon-upload2' @click='uploadClick(item,index)'></i>
                          <i class='el-icon-delete' @click='handleRemove(item,index)'></i></div>
                      </div>
                    </div>

                  </div>
                </el-form-item>
              </div-border>

            </el-form>
            <div class='btnContainer'>
              <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addClick'>
                {{ dilogNumber === 1 ? '添加' : '修改' }}
              </el-button>
              <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
            </div>
          </div>

        </div>

      </div>

    </el-dialog>

    <el-dialog title='详情供应商日常考核' :visible.sync='detailDialogVisible' width='673px' center>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
            <p>{{ detailData.state |stats }}</p>
          </div>
          <div class='baseInfoContent'>
            <el-form :model='detailData' label-position='left'>
              <el-form-item label='供应商名称:'>
                <span>{{ detailData.supplierName }}</span>
              </el-form-item>
              <el-form-item label='扣款金额:'>
                <span>{{ detailData.deduction }}</span>
              </el-form-item>
              <el-form-item label='扣款时间:'>
                <span>{{ detailData.deductionTime }}</span>
              </el-form-item>
              <el-form-item label='税率:'>
                <span>{{ detailData.taxRate }}</span>
              </el-form-item>
              <el-form-item label='扣款原由:'>
                <span>{{ detailData.deductionReasonDesc }}</span>
              </el-form-item>
              <el-form-item label='详情原由:'>
                <span>{{ detailData.deductionReasonDetail }}</span>
              </el-form-item>


            </el-form>
          </div>
          <div class='operation'
               v-if='detailData.attachmentList  && detailData.attachmentList.length>0'>
            <div class='operationTitle'>
              <div class='line' />
              <span>附件信息</span>
            </div>
            <div class='baseInfoContent'>
              <div style='display: flex'>
                <el-form :model='detailData' label-position='left' style='width: 100%'>
                  <el-row :gutter='30' style='width: 100%' v-for='(item,index) in detailData.img'
                          :key='`${index}b`'>
                    <el-col :span='14'>
                      <el-form-item>
                        {{ item.name }}
                      </el-form-item>

                    </el-col>
                    <el-col :span='7'>
                      <el-form-item>{{ item.uploadTime }}</el-form-item>
                    </el-col>
                    <el-col :span='3'>
                      <el-form-item>
                        <i class='el-icon-zoom-in' @click='handlePictureCardPreview(item,index)'
                           v-if="item.name.substring(item.name.indexOf('.')) == '.jpeg'
                           ||item.name.substring(item.name.indexOf('.')) == '.jpg'
                             ||item.name.substring(item.name.indexOf('.')) == '.png'
                             || item.name.substring(item.name.indexOf('.')) == '.gif'"></i>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </div>
          <div class='operation'>
            <div class='operationTitle'>
              <div class='line' />
              <span>操作记录</span>
            </div>
            <div class='baseInfoTable mt10'>
              <el-table :data='detailData.operateRecordList' border max-height='300'>
                <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
                <el-table-column prop='operateType' label='操作类型' align='center' />
                <el-table-column prop='operationName' label='操作人' align='center' />
                <el-table-column prop='remark' label='备注' align='center' />
              </el-table>
            </div>
          </div>
        </div>

      </div>

    </el-dialog>
    <el-dialog :visible.sync='dialogVisible' append-to-body>
      <img width='100%' :src='dialogImageUrl' alt=''>
    </el-dialog>
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl,
  } from '@/config/env';
  import uploadImg from '@/components/uploadImg';
  import divBorder from '@/components/divBorder';
  import steps from '@/components/steps';
  import {
    dailyReviewPageList,
    dailyReviewUpdate,
    dailyReviewAdd,
    dailyReviewDetail,
    dailyReviewCancelApplyFor,
  } from '@/service/contract';
  import {
    getHighwayParam, supplierList,

  } from '@/service/basicfile';
  import {
    highwayLineSelectWaterSupplier,
  } from '@/service/financial';
  import {
    selectListBySourceId,

  } from '@/service/getData';
  import {
    formatTime, getSessionStore,
  } from '@/config/mUtils';
  import { shipDeployPublicSelectPort } from '@/service/vehiclelog';

  export default {
    components: {
      uploadImg,
      divBorder,
      steps,
    },

    data() {
      return {
        form: {
          supplierName: '',
          deductionReasonDesc: '',
          startDate: '',
          endDate: '',
          isStatement: '',
          page: 1,
          rows: 10,
        },
        total: 0,
        tableLoad: false,
        tableData: [],
        detailDialogVisible: false,
        detailData: {},
        modifyData: {
          supplierType: '',
          deduction: '',//扣款金额
          supplierName: '',//供应商id
          deductionReasonDetail: '',
          deductionReasonDesc: '',
          deductionTime: '',
          taxRate: '',
          attachmentIdStr: '',
          img: [],
        },
        stepData: [
          {
            title: '张三发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
          {
            title: '财务部 张三通过',
            time: '2021-9-30 14:09:23',
            state: 'success',
            remark: '原因xxxxxx',
          },
          {
            title: '技术部 李四拒绝',
            time: '2021-9-30 14:09:23',
            state: 'failure',
            remark: '原因xxxxxx',
          },
          {
            title: '张三重新发起',
            time: '2021-9-30 14:09:23',
            state: '',
            remark: '',
          },
        ],
        baseImgUrl: baseImgUrl + '/',
        dialogImageUrlList: [],
        uploadUrl: '',
        dialogTitle: '',
        dialogVisible: false,
        addFlag: false,
        addLoad: false,
        // 1 为添加 2 修改
        dilogNumber: 1,
        dialogImageUrl: '',
        uploadFlag: false,//替换
        uploadIndex: '',//替换索引
        uploadData: {
          fileType: '0',
        },
        startCastingTimeOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 86400000;
          },
        },
        HighwaySelect: [],
        WaterSelect: [],
        selectData: [],
        selectMap: new Map(),
        rules: {
          plan: {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
          deductionReasonDesc: [
            {
              required: true,
              message: '请简单描诉扣款原由',
              trigger: 'blur',
            },
            {
              min: 3,
              max: 9,
              message: '长度在 3 到 9 个字符',
              trigger: 'blur',
            },
          ],
          deductionReasonDetail: {
            required: true,
            message: '请详细描述扣款原由',
            trigger: 'blur',
          },
          supplierType: {
            required: true,
            message: '请选择评审类型',
            trigger: 'blur',
          },
          deduction: {
            required: true,
            message: '请输入扣款金额',
            trigger: 'blur',
          },
          supplierName: {
            required: true,
            message: '请选择供应商',
            trigger: 'blur',
          },
          taxRate: {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
          deductionTime: {
            required: true,
            message: '请选择扣款时间',
            trigger: 'blur',
          },
          img: {
            required: false,
            message: '请选择合同照片',
            trigger: 'blur',
          },

        },

      };

    },
    // <el-option label="待审核" value="1"></el-option>
    //   <el-option label="已通过" value="2"></el-option>
    //   <el-option label="已拒绝" value="3"></el-option>
    //   // <el-option label="已取消" value="4"></el-option>
    filters: {
      stats(val) {
        let text = '';
        switch (val) {
          case 1:
            text = '待审核';
            break;
          case 2:
            text = '已通过';
            break;
          case 3:
            text = '已拒绝';
            break;
          case 4:
            text = '已取消';
            break;
        }
        return text;
      },
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd');
        } else {
          return '';
        }


      },
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
    },
    created() {
      this.$nextTick(() => {
        this.init();
      });
    },
    methods: {
      isStatementFormat(r, c, cellValue) {
        switch (cellValue) {
          case 0:
            return '否';
          case 1:
            return '是';
        }
      },
      init() {
        this.uploadUrl = baseUrl + '/web/attachmentFtp/upload';
        this._dailyReviewPageList();
      },
      async _getHighwayParam() {
        let HighwayRes = await getHighwayParam();
        if (HighwayRes.status !== 0) return this.$message.error(HighwayRes.message);
        this.HighwaySelect = HighwayRes.data;
        HighwayRes.data.forEach((item, index) => {
          this.selectMap.set(item.name, item.id);
        });
      },
      // 结束时间
      dateChange(val) {
        if (this.form.endDate && this.form.startDate && (this.form.endDate < this.form.startDate)) {
          if (val == this.form.endDate) this.form.endDate = '';
          if (val == this.form.startDate) this.form.startDate = '';
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      //港口及其他
      async _shipDeployPublicSelectPort() {
        let res = await supplierList();
        if (res.status !== 0) return this.$message.error(res.message);
        res.data.forEach((item, index) => {
          this.selectMap.set(item.supplier_name, item.id);
        });
        return res.data;

      },

      async _highwayLineSelectWaterSupplier() {
        let WaterRes = await highwayLineSelectWaterSupplier();
        if (WaterRes.status !== 0) return this.$message.error(WaterRes.message);
        this.WaterSelect = WaterRes.data;
        WaterRes.data.forEach((item, index) => {
          this.selectMap.set(item.name, item.id);
        });
        return WaterRes.data;
      },
      async _dailyReviewPageList() {
        this.tableLoad = true;
        let res = await dailyReviewPageList(this.form);
        this.tableLoad = false;
        if (res.status !== 0) {
          return this.$message.error(res.message);
        }
        this.tableData = res.data.records;
        this.total = res.data.total;
      },
      addBtn() {
        // 1 为添加 2 修改
        this.dilogNumber = 1;
        this.dialogTitle = '新增日常考核';
        this.addFlag = true;
      },
      searchBtn() {
        this.form.page = 1;
        this._dailyReviewPageList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;

      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._dailyReviewPageList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._dailyReviewPageList();
      },
      // 详情
      async detailClick(row) {
        let res = await dailyReviewDetail({ id: row.id });
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        let res2 = await selectListBySourceId(row.id);
        if (res2.status !== 0) return this.$message.error(res2.message);
        //拼接 附件数组
        let array = res2.data.map(item => {
          return {
            name: item.attachmentName,
            url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
            status: 'success',
            id: item.id,
            uploadTime: item.uploadTime,
          };
        });
        this.$set(this.detailData, 'img', array);
        this.detailDialogVisible = true;
      },
      async modifyClick(row) {
        // 1 为添加 2 修改
        this.dilogNumber = 2;
        this.dialogTitle = '修改日常考核';
        this.addFlag = true;
        this.modifyData = {

          supplierType: row.supplierType,
          deduction: row.deduction,//扣款金额
          supplierName: row.supplierName,//供应商id
          deductionReasonDetail: row.deductionReasonDetail,
          deductionReasonDesc: row.deductionReasonDesc,
          taxRate: row.taxRate,
          deductionTime: row.deductionTime,
          id: row.id,
        };
        let res = await selectListBySourceId(row.id);
        if (res.status !== 0) return this.$message.error(res.message);
        //将拼接id字段转类型
        this.modifyData.attachmentIdStr = '';
        //拼接 附件数组
        let array = res.data.map(item => {
          return {
            name: item.attachmentName,
            url: this.baseImgUrl + item.attachmentGroup + '/' + item.attachmentPath,
            status: 'success',
            id: item.id,
          };
        });

        this.$set(this.modifyData, 'img', array);
        console.log(this.modifyData.img);
        //flag 是否清空供应商 ，2 修改不清空
        await this.radioChange(row.supplierType, 2);

      },
      rejectClick(row) {
        this.$confirm('确认要取消日常审核吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await dailyReviewCancelApplyFor({ id: row.id });
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            this._dailyReviewPageList();
          })
          .catch(() => {
          });
      },
      beforeAvatarUpload(file) {
        // const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
        // const isJPG =TypeArr.includes(file.type)
        const isLt10M = file.size / 1024 / 1024 < 10;
        // if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
        if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB');

        // return isJPG && isLt10M
        this.addLoad = true;
        return isLt10M;
      },
      uploadChange(file, fileList) {
        if (this.uploadFlag) {
          this.modifyData.img.splice(this.uploadIndex, 1, file);
          this.uploadFlag = false;
        } else {
          this.modifyData.img = fileList;
          console.log(fileList);
        }
        if (Object.keys(file)
          .includes('response')) {
          if (file.response.status == -1) {
            this.modifyData.img.splice(this.modifyData.img.indexOf(file), 1);
          }
        }

      },
      handleRemove(item, index) {
        this.modifyData.img.splice(index, 1);
      },
      handlePictureCardPreview(item, index) {
        console.log(item);
        let token = getSessionStore('token');
        this.dialogImageUrl = baseUrl + '/web/attachmentFtp/download?attachmentId=' + (item.id || item.response.data.id) + '&access_token=' + token;

        this.dialogVisible = true;
      },
      //外部上传方法，替换
      uploadClick(item, index) {
        this.uploadIndex = index;
        this.uploadFlag = true;
        this.$refs.upload.$refs['upload-inner'].handleClick();

      },
      //附件上传成功回调
      uploadImgFun(res, val) {
        this.addLoad = false;
        if (res.status == 0) {
          this.$message.success(res.message);
          // if (this.uploadFlag){//如果为替换，得到索引值进行替换
          //   this.dialogImageUrlList.splice(this.uploadIndex,1,{'id':res.data.id})
          //   console.log( this.dialogImageUrlList)
          //   this.uploadFlag =false;
          // }else {
          //   this.dialogImageUrlList.push({'id':res.data.id})
          //   console.log( this.dialogImageUrlList)
          // }

        } else {
          this.$message.error(res.message);
          this.uploadFlag = false;

        }
      },
      closeDialog() {
        this.dialogVisible = false;
      },
      addClick() {
        this.$refs.ruleForm.validate(async (valid, val) => {
          // if(Object.keys(val).length === 1) valid=true;
          if (valid) {
            // 1 为添加 2 修改
            if (this.dilogNumber === 1) {
              this.modifyData.img.forEach((item, index) => {
                if (this.modifyData.img.length - 1 === index) {
                  this.modifyData.attachmentIdStr += item.response.data.id;
                } else {
                  this.modifyData.attachmentIdStr += item.response.data.id + ',';
                }

              });
              this.modifyData.supplierId = this.selectMap.get(this.modifyData.supplierName);
              this.addLoad = true;
              let res = await dailyReviewAdd(this.modifyData);
              this.addLoad = false;
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              console.log('添加');
            } else {
              let data = JSON.parse(JSON.stringify(this.modifyData));
              data.img.forEach((item, index) => {

                if (data.img.length - 1 === index) {
                  console.log(Object.keys(item)
                    .includes('response'));
                  if (Object.keys(item)
                    .includes('response')) {
                    data.attachmentIdStr += item.response.data.id;
                  } else {
                    data.attachmentIdStr += item.id;
                  }

                } else {
                  if (Object.keys(item)
                    .includes('response')) {
                    data.attachmentIdStr += item.response.data.id + ',';
                  } else {
                    data.attachmentIdStr += item.id + ',';
                  }

                }

              });
              data.supplierId = this.selectMap.get(data.supplierName);
              this.addLoad = true;
              let res2 = await dailyReviewUpdate(data);
              this.addLoad = false;
              if (res2.status !== 0) return this.$message.error(res2.message);
              this.$message.success(res2.message);
            }
            for (const argumentsKey in this.modifyData) {
              if (argumentsKey == 'img') {
                this.modifyData[argumentsKey] = [];
              } else {
                this.modifyData[argumentsKey] = '';
              }
            }
            await this._dailyReviewPageList();
            this.addFlag = false;
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.$refs.ruleForm.resetFields();
        this.modifyData.img = [];
        this.addFlag = false;
        // this.$emit("addclose",false)
      },
      //flag 是否清空供应商 ，2 修改不清空
      async radioChange(type, flag) {
        flag === 1 ? this.modifyData.supplierName = '' : '';
        switch (type) {
          case 1:
            await this._getHighwayParam();
            this.selectData = this.HighwaySelect;
            break;
          case 2:
            this.selectData = await this._highwayLineSelectWaterSupplier();
            break;
          case 3:
            let arr = await this._shipDeployPublicSelectPort();
            this.selectData = arr.map(item => {
              return {
                name: item.supplier_name,
                id: item.id,
              };
            });
            break;

        }
      },

    },
  };
</script>


<style lang='scss' scoped>
  .consignor-daily {
    /*width:100%;*/
    padding: 20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav {
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;
      margin-bottom: 10px;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      .tableContainer {
        margin-bottom: 25px;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }

          .el-table th > .cell {
            font-weight: 700 !important;
          }
        }
      }
    }

    ::v-deep .detail {

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .el-form-item {
            margin-bottom: 2px;

            .el-form-item__label {
              /*color: #060606;*/
              font-weight: 700;
            }
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }

    ::v-deep .add {

      .el-form-item__label {
        font-weight: 700;
      }

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .center-f {
            display: flex;
          }

          .yang {
            .el-form-item {
              .el-form-item__error {
                left: 40px;
              }

              margin-bottom: 15px;

              .el-form-item__label {
                width: 150px !important;
                /*color: #060606;*/
              }

              .el-input {
                width: 430px;
              }

              .el-textarea {
                width: 250px;

              }
            }

          }

          .el-upload-list__item {
            width: 100px;
            height: 100px;
          }

          .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 100px;
          }

          .imgUp {
            .upload-demo {
              display: flex;
            }

            .upload {
              font-size: 17px;
              display: flex;
              align-items: center;
              justify-content: space-between;

              i {
                margin-right: 10px;
              }

              i:hover {
                color: #00e1ff;
              }
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

    }
  }

  ::v-deep {
    .el-form--inline .el-form-item {
      margin-bottom: 5px;
    }

    .el-table th, .el-table td {
      padding: 0;
    }
  }
</style>
